// GAVION rep stats: coût d'acquisition (Paramètres → Coûts, Rapports → Coûts & CAC). Admins seulement.
export const costsFr = {
  settings: {
    title: "Coûts",
    intro:
      "Rémunération des représentants et frais mensuels, pour calculer le coût par appel, par démo et le coût d'acquisition client (CAC). Chaque ligne s'applique à partir de sa date d'effet : l'historique est conservé et les mois passés gardent leurs anciens taux.",
    saved: "Enregistré",
    deleted: "Supprimé",
    delete: "Supprimer",
    delete_aria: "Supprimer la ligne du %{date}",
    add: "Ajouter",
    effective_from: "En vigueur à partir du",
    history: "Historique",
    compensation: {
      title: "Rémunération par représentant",
      rep: "Représentant",
      pay_type: "Type de paie",
      hourly: "Horaire",
      salary: "Salaire mensuel",
      hourly_rate: "Taux horaire ($/h)",
      monthly_salary: "Salaire mensuel ($)",
      commission_pct: "Commission (% des revenus gagnés)",
      bonus_per_deal: "Prime par deal gagné ($)",
      empty: "Aucune rémunération saisie.",
      summary_hourly: "%{rate} $/h",
      summary_salary: "%{amount} $/mois",
      summary_commission: "+ %{pct} % des revenus",
      summary_bonus: "+ %{amount} $ par deal",
      hint: "Horaire : payé sur le temps de session d'appels.",
    },
    fixed: {
      title: "Frais fixes mensuels",
      category: "Catégorie",
      monthly_amount: "Montant mensuel ($)",
      label: "Description (facultatif)",
      empty: "Aucun frais fixe saisi.",
      hint: "Un nouveau montant remplace le précédent de la même catégorie à partir de sa date d'effet. Entrez 0 pour arrêter un frais.",
    },
    marketing: {
      title: "Dépenses marketing mensuelles (facultatif)",
      channel: "Canal (source du deal)",
      empty: "Aucune dépense marketing saisie.",
    },
    categories: {
      telephony: "Téléphonie (VoIP.ms, etc.)",
      software: "Logiciels",
      other: "Autres",
      marketing: "Marketing",
    },
    basis: {
      title: "Montant des deals",
      label: "Le montant d'un deal représente",
      unset: "Non précisé",
      one_time: "Un paiement unique",
      monthly: "Un montant mensuel (abonnement)",
      annual: "Un montant annuel",
      hint: "Sert au délai de récupération : il n'est calculé que pour des montants mensuels ou annuels.",
    },
    errors: {
      required: "Champ requis.",
      amount: "Entrez un montant entre 0 et 1 000 000.",
      pct: "Entrez un pourcentage entre 0 et 100.",
      date: "Entrez une date valide.",
      duplicate: "Une ligne existe déjà à cette date.",
      save: "Impossible d'enregistrer.",
    },
  },
  report: {
    title: "Coûts & CAC",
    description:
      "Coût total, coût par appel et par démo, coût d'acquisition client, par représentant et pour l'équipe (admins).",
    rep_title: "Coûts & CAC (admins)",
    empty: "Aucun coût n'a été saisi : rien à calculer.",
    empty_link: "Saisir les coûts dans Paramètres → Coûts",
    no_compensation:
      "Aucune rémunération saisie pour ce représentant : seule sa part des frais fixes est comptée.",
    team: "Équipe",
    by_rep: "Par représentant",
    by_channel: "Marketing par canal",
    rep: "Représentant",
    channel: "Canal",
    spend: "Dépenses",
    unallocated:
      "%{amount} de frais fixes ne sont attribués à aucun représentant (aucune session d'appels sur la période).",
    how: "Comment c'est calculé : %{label}",
    na: "n/d",
    months: "%{value} mois",
    ratio: "%{value} ×",
    metrics: {
      total: "Coût total",
      pay: "Paie",
      commission: "Commissions",
      fixed: "Frais fixes",
      fixed_share: "Part des frais fixes",
      marketing: "Marketing",
      cost_per_dial: "Coût par appel",
      cost_per_conversation: "Coût par conversation",
      cost_per_demo: "Coût par démo",
      cac: "Coût d'acquisition client (CAC)",
      revenue_won: "Revenus gagnés",
      revenue_cost_ratio: "Ratio revenus / coût",
      payback_months: "Délai de récupération",
      marketing_cost_per_deal: "Coût marketing par deal",
      deals_won: "Deals gagnés",
    },
    formulas: {
      total:
        "Paie + commissions + part des frais fixes (+ marketing pour l'équipe).",
      pay: "Horaire : heures de session × taux en vigueur ce jour-là. Salaire : salaire mensuel ÷ nombre de jours du mois, pour chaque jour de la période.",
      commission:
        "% des revenus gagnés + prime fixe par deal gagné, selon la rémunération en vigueur le jour de la vente.",
      fixed:
        "Téléphonie, logiciels et autres : montant mensuel ÷ jours du mois, pour chaque jour de la période. Réparti entre représentants au prorata de leur temps de session.",
      fixed_share:
        "Frais fixes de la période × temps de session du représentant ÷ temps de session de l'équipe.",
      marketing:
        "Dépenses marketing mensuelles ÷ jours du mois, pour chaque jour. Comptées pour l'équipe seulement.",
      cost_per_dial: "Coût total ÷ appels.",
      cost_per_conversation: "Coût total ÷ conversations.",
      cost_per_demo: "Coût total ÷ démos bookées.",
      cac: "Coût total ÷ deals gagnés dans la période.",
      revenue_won: "Somme des montants des deals gagnés dans la période.",
      revenue_cost_ratio: "Revenus gagnés ÷ coût total.",
      payback_months:
        "CAC ÷ revenu mensuel moyen par deal gagné (montant ÷ 12 si les montants sont annuels). n/d si les montants sont des paiements uniques ou non précisés (Paramètres → Coûts).",
      marketing_cost_per_deal:
        "Dépenses marketing du canal ÷ deals gagnés de ce canal dans la période. N'inclut ni la paie, ni les commissions, ni les frais fixes : ce n'est pas le CAC.",
      deals_won: "Deals non archivés passés à « Gagné » dans la période.",
    },
  },
};
